import { IApplicationState } from '../../types/redux';
import { hasValidPhone } from '../../utils/agent';

export function getSellers(state: IApplicationState) {
  const {
    newbuildingInfo: { sellers },
  } = state;

  if (sellers) {
    return sellers;
  }

  return [];
}

export function getSellersWithValidPhones(state: IApplicationState) {
  return getSellers(state).filter(hasValidPhone);
}
